// extracted by mini-css-extract-plugin
module.exports = {"badge":"index-module--badge--3UqoO","DAOInfoSection":"index-module--DAOInfoSection--2dShI","actions":"index-module--actions--3gyyv"};